import { useMemo } from 'react';
import { EventTag, User } from '../types';
import { filterOwnersByPrivateTags } from '../utils/eventUtils';

export const useEligibleCollaborators = (
  users: readonly User[],
  tags: EventTag[] | undefined,
  eventTagIds: number[],
  ownerId: number,
) =>
  useMemo(
    () =>
      filterOwnersByPrivateTags(
        users.filter(
          (user) => user.id !== ownerId && !!user.full_name && user.permissions.includes('can_work_on_issue'),
        ),
        tags ?? [],
        eventTagIds,
      ),
    [users, tags, eventTagIds, ownerId],
  );
